const getters = {
  token: (state) => state.user.token,
  role: (state) => state.user.role,
  progress: (state) => state.upload.progress, // upload progress bar
  cancelProgress: (state) => state.upload.cancel,
  queue: (state) => state.upload.queue,
};

export default getters;
